//VisualBriefSlideList.jsx
import React, { useCallback, useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import { useSelector } from 'react-redux';
import MainLayout from '../../layouts/MainLayout';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faPlus } from '@fortawesome/free-solid-svg-icons';

const VisualBriefSlideList = () => {
    const location = useLocation();
    const authState = useSelector(state => state.authReducer);
    const navigate = useNavigate();
    const [fetchData, { loading }] = useFetch();
    const [vbMasterId, setVbMasterId] = useState(location.state?.vbMasterId || '');
    const [vbTitle, setVbTitle] = useState(location.state?.title || '');
    const [noOfSlides, setNoOfSlides] = useState(location.state?.noOfSlides || 0);

    // console.log("vbMasterId: ",vbMasterId,vbTitle,noOfSlides);

    // useEffect(() => {
    //     // Update state variables if location state changes
    //     setVbMasterId(location.state?.vbMasterId || '');
    //     setVbTitle(location.state?.title || '');
    //     setNoOfSlides(location.state?.noOfSlides || 0);
    // }, [location.state]);

    const [vbSlides, setSlides] = useState([]);
    const [vbComments, setVBComments] = useState([]);
    
    const [selectedSlideId, setSelectedSlideId] = useState('');
    const [viewImageClicked, setViewImageClicked] = useState(false);
    const [viewCommentsClicked, setViewCommentsClicked] = useState(false);
    const fromRouteInitialized = useRef(false);
    const [viewSlideCommentsClicked, setViewSlideCommentsClicked] = useState(false);
    const purposeInitialized = useRef(false);

    const fromRoute = (location?.pathname || '').split('/').pop() || '';
    const [toRoute, setToRoute] = useState('');
    useEffect(() => {
        if (fromRoute && !fromRouteInitialized.current) {
        let toRoute = '';
        switch (fromRoute) {
            case 'visualbrief-myvb':
                toRoute = 'visualbrief-myvb';
                break;
            case 'visualbrief-publicvb':
                toRoute = 'visualbrief-publicvb';
                break;
            case 'visualbrief-vbforme':
                toRoute = 'visualbrief-vbforme';
                break;
            default:
                toRoute = 'visualbrief-myvb';
                break;
        }
      setToRoute(toRoute);
      fromRouteInitialized.current = true;
    }
  }, [location.pathname]);

    //vbSlideList
    const fetchSlidesList = useCallback(() => {
        const config = {
            url: "/vbslides/allslides",
            method: "post",
            headers: { Authorization: authState.token },
            data: { vbMasterId: vbMasterId }
        };
        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (Array.isArray(response)) {
                    setSlides(response);
                }
                else {
                    console.error("Slides not found!");
                }
            })
            .catch(error => {
                console.error("Error fetching slides: ", error);
            });
    }, [authState.token, fetchData]);

    const fetchComments = useCallback(() => {
            const config = {
                url: "/vbslidecomments/all",
                method: "post",
                headers: { Authorization: authState.token },
                data: { vbMasterId: vbMasterId }
            };
            fetchData(config, { showSuccessToast: false })
                .then(response => {
                        // console.log("ppp...",response);
                        setVBComments(response.vbslideComments);
                })
                .catch(error => {
                    console.error("Error fetching comments: ", error);
                });
        }, [authState.token, fetchData]);
    
        useEffect(() => {
            fetchSlidesList();
            fetchComments()
        }, [fetchSlidesList,fetchComments]);
    
        useEffect(() => {
            // console.log("Updated Comments...............:", vbComments);
        }, [vbComments]);

    const handleSlideDescView = (itemId) => {
        setSelectedSlideId(prevId => (prevId === itemId ? null : itemId));
        setViewCommentsClicked(false);
        setViewImageClicked(false)
    };

    const handleSlideImageClick = () => {
        setViewImageClicked(!viewImageClicked);
    };

    const handleSlideCommentsClick = () => {
        setViewCommentsClicked(!viewCommentsClicked);
    };

    const handleCommentsView = () => {
        // console.log("dddd...",vbComments);
        setViewCommentsClicked(!viewCommentsClicked);
        setViewImageClicked(false)
    };

    const handleDeleteClick = (vbSlideId) => {
        const config = { url: `/vbslides/${vbSlideId}`, method: "delete", headers: { Authorization: authState.token } };
        fetchData(config).then(() => fetchSlidesList());
    };

    const handleAddSlide = (vbMasterId, vbTitle, noOfSlides) => {
        navigate("/vbslide/add", { state: { vbMasterId, vbMasterTitle: vbTitle, noOfSlides: noOfSlides } });
    };
    
    return (
        <MainLayout>
            <div className='py-4 px-4 bg-gradient-to-r from-gray-600 via-gray-500 to-gray-600 mt-12'>
                <div className='flex justify-between bg-green-600'>
                    <h3 className='text-lg py-2 px-2 text-white  '>Manage {vbTitle} Slides</h3>
                    <Tooltip text={"View Comments"} position={"top"}>
                        <span className='ml-auto px-2 py-2 mr-4 text-yellow-200 cursor-pointer' onClick={() => handleCommentsView()}>
                            <i className="fa-solid fa-comments"></i>
                        </span>
                    </Tooltip>
                </div>

                {loading ? (
                    <Loader />
                ) : (
                    <div>
                        <div className="flex justify-between items-center mt-2">
                            <div>
                                <h2 className=" text-yellow-200 rounded p-2">Slides List for {vbTitle}</h2> 
                            </div>
                            <div>
                                <button className="w-40" onClick={() => handleAddSlide(vbMasterId, vbTitle, noOfSlides)}><FontAwesomeIcon icon={faPlus} style={{ marginRight: '5px' }} />Add New</button>;
                            </div>
                        </div>
                        <div>
                            {vbSlides && vbSlides.length === 0 ? (
                                <div className='h-[300px] flex align-middle items-center justify-center text-yellow-300 text-lg'>
                                    No records found!
                                </div>
                            ) : (
                                vbSlides.map((slides, index) => (
                                    <div key={slides._id} className='bg-white my-1 p-4 text-gray-600 rounded-md shadow-md'>
                                        <div className='flex'>
                                            <div className='font-medium'>{slides.slideNumber} {'.'} {slides.title}</div>
                                            <div className='ml-auto'>
                                                <Tooltip text={"View Slide"} position={"top"}>
                                                    <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleSlideDescView(slides._id)}>
                                                        <i className="fa-solid fa-eye"></i>
                                                    </span>
                                                </Tooltip>
                                                <Tooltip text={"Edit Slide"} position={"top"}>
                                                    <Link 
                                                        to={`/vbslide/${slides._id}`} 
                                                        state={{ vbMasterId, vbMasterTitle: vbTitle, noOfSlides }}
                                                        className='mr-4 text-green-600 cursor-pointer'
                                                    >
                                                        <i className="fa-solid fa-pen"></i>
                                                    </Link>
                                                </Tooltip>
                                                <Tooltip text={"Delete Slide"} position={"top"}>
                                                    <span className='ml-auto mr-4 text-blue-500 cursor-pointer' disabled={slides.isLocked} onClick={() => handleDeleteClick(slides._id)}>
                                                        <i className="fa-solid fa-trash"></i>
                                                    </span>
                                                </Tooltip>
                                            </div>
                                        </div>
                                        {selectedSlideId === slides._id && (
                                            <div className='bg-gray-600 text-white mt-4 p-4 rounded-md'>
                                                <h2 className='text-yellow-200 text-m font-bold mb-2'>{slides.slideNumber}. {slides.title}</h2>
                                                <p className='mt-2 mb-2 px-2 py-2 border border-white'><strong>Description:</strong> {slides.slideDesc}</p>
                                                {slides.hasAddlDesc && (
                                                    <p className='mt-2 mb-2 px-2 py-2 border border-yellow-200'><strong>Additional Description:</strong> {slides.addlDesc}</p>
                                                )}
                                                {slides.hasTTS && (
                                                    <div className='mt-2 mb-2 px-2 py-2 border border-blue-400'>
                                                        <p><strong>Speech Text:</strong> {slides.ttsText}</p>
                                                        <p><strong>Speech Language:</strong> {slides.ttsLang}</p>
                                                        <p><strong>Speech Speed:</strong> {slides.ttsSpeed}</p>
                                                        <p><strong>Speech Pitch:</strong> {slides.ttsPitch}</p>
                                                        <p><strong>Speech Volume:</strong> {slides.ttsVolume}</p>

                                                    </div>
                                                )}
                                                <div className='mt-2 mb-2 px-2 py-2 border border-orange-400'>
                                                    <p><strong>Slide Website URL:</strong> {slides.websiteUrl}</p>
                                                    <p><strong>Slide YouTube URL:</strong> {slides.youtubeUrl}</p>
                                                    {/* <p><strong>Slide TED URL:</strong> {slides.tedUrl}</p> */}
                                                    {/* <p><strong>Slide Vimeo URL:</strong> {slides.vimeoUrl}</p> */}
                                                    <p><strong>Slide Think5Whys URL:</strong> {slides.othersVideoURL}</p>
                                                    {/* <p><strong>Slide Other URL:</strong> {slides.youtubeURL}</p> */}
                                                </div>
                                                <p><strong>Is Presenting:</strong> {slides.isPresenting ? "Yes" : "No"}</p>

                                                <p><strong>Date Created:</strong> {new Date(slides.dateCreated).toLocaleDateString()}</p>

                                                <div>
                                                    <Tooltip text={"View Image"} position={"top"}>
                                                        <span className='ml-auto mr-4 text-yellow-200 cursor-pointer' onClick={() => handleSlideImageClick()}>
                                                            <i className="fa-solid fa-image"></i>
                                                        </span>
                                                    </Tooltip>
                                                    <Tooltip text={"Comments"} position={"top"}>
                                                        <span className='ml-auto mr-4 text-yellow-200 cursor-pointer' onClick={() => handleSlideCommentsClick()}>
                                                            <i className="fa-solid fa-comments"></i> {/* Changed the icon to comments icon */}
                                                        </span>
                                                    </Tooltip>
                                                    {viewImageClicked && (
                                                        // <div className='ml-2 mr-2 page-content flex align-middle justify-center' style={{ maxWidth: 'calc(100vw)' }}
                                                        //     dangerouslySetInnerHTML={{ __html: slides.slideImageData }} />
                                                        <div className="mt-2 flex justify-center">
                                                            <img 
                                                                src={
                                                                    `/api/downloads/visualbrief/${slides.slideImageData}.png` 
                                                                }
                                                                alt={"No Image " + slides.title} 
                                                                className="rounded-md flex justify-items-center"
                                                            />
                                                        </div>
                                                    )}
                                                    {/* {console.log("Slides Comments:", slides.comments)} */}
                                                    {viewCommentsClicked && (
                                                        <div>
                                                            <h3 className='text-yellow-200'>Comments:</h3>
                                                            {slides.comments.map((commentObj, commentIndex) => (
                                                                <p key={commentIndex}>{commentObj.comment}</p>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))
                            )}
                        </div>
                        { viewCommentsClicked && (
                            <div className='mt-4 mb-4 px-2 py-2'>
                                <p>Presentation {vbTitle} Comments:</p>
                                {vbComments.map((comment, index) => (
                                    <div key={comment._id} className='bg-gray-700 my-1 p-4 text-white rounded-md shadow-md'>
                                        <p><strong>Slide:</strong> {comment.vbSlideTitle}</p>
                                        <p><strong>By:</strong> {comment.userName}</p>
                                        <p><strong>Comment:</strong> {comment.userComment}</p>
                                        <p><strong>Date:</strong> {new Date(comment.dateCommented).toLocaleDateString()}</p>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </MainLayout>
    );
};

export default VisualBriefSlideList;


